import { useState } from "react";
import { Loader2, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { PLATFORMS } from "./meta";

const SOURCES = [
  { key: "mirror", label: "FusebillSync mirror", hint: "fast, refreshed nightly" },
  { key: "live", label: "Live from Stax Bill", hint: "slower, up to the minute" },
];

function Pill({ on, onClick, children, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid} aria-pressed={on}
            className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${on ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"}`}>
      {children}
    </button>
  );
}

export function RunForm({ busy, onRun }) {
  const [f, setF] = useState({ platforms: PLATFORMS.map((p) => p.key), territory: "", domain: "", source: "mirror" });
  const toggle = (k) => setF((x) => ({ ...x, platforms: x.platforms.includes(k) ? x.platforms.filter((y) => y !== k) : [...x.platforms, k] }));
  return (
    <Card className="border-slate-200 p-4 shadow-sm" data-testid="bsp-run-form">
      <div className="flex flex-wrap items-end gap-x-6 gap-y-3">
        <div className="space-y-1.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Platforms</div>
          <div className="flex gap-1.5">{PLATFORMS.map((p) => (
            <Pill key={p.key} on={f.platforms.includes(p.key)} onClick={() => toggle(p.key)} testid={`bsp-platform-${p.key}`}>{p.label}</Pill>))}</div>
        </div>
        <label className="space-y-1.5"><span className="block text-[11px] font-semibold uppercase tracking-wide text-slate-500">Territory</span>
          <Input value={f.territory} onChange={(e) => setF({ ...f, territory: e.target.value })} placeholder="all" className="h-9 w-44 font-mono text-xs" data-testid="bsp-territory" /></label>
        <label className="space-y-1.5"><span className="block text-[11px] font-semibold uppercase tracking-wide text-slate-500">Domain</span>
          <Input value={f.domain} onChange={(e) => setF({ ...f, domain: e.target.value })} placeholder="all" className="h-9 w-52 font-mono text-xs" data-testid="bsp-domain" /></label>
        <div className="space-y-1.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Tracked items from</div>
          <div className="flex gap-1.5">{SOURCES.map((s) => (
            <Pill key={s.key} on={f.source === s.key} onClick={() => setF({ ...f, source: s.key })} testid={`bsp-source-${s.key}`}>
              {s.label} <span className="opacity-60">· {s.hint}</span></Pill>))}</div>
        </div>
        <Button className="ml-auto" onClick={() => onRun(f)} disabled={busy || !f.platforms.length} data-testid="bsp-run">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Play className="h-4 w-4" />} Run preview</Button>
      </div>
    </Card>
  );
}
